module.exports = __webpack_public_path__ + "media/images/icons/vehicle-storage-small-10x10-e7a632cec8f06f982e04674898291c73.png";